export const supportEmail = 'support@authentigate.io'
export const siteName = 'AuthentiGate'
